import { useState, useEffect } from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Stepper,
  Step,
  StepLabel,
  StepContent,
  Button,
  Typography,
  Tooltip,
} from "@mui/material";
import SiteIcons from "@/components/SiteIcons/SiteIcons";
import { parseAdaPath, formatTimestamp } from "@/utils/util";

export default function FileHistoryModal({ row, initialOpen = false }) {
  const [open, setOpen] = useState(initialOpen);
  const [steps, setSteps] = useState([]);

  useEffect(() => {
    createStepData();
  }, [row]);

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const createStepData = () => {
    const allSteps = [
      {
        label: "Confirmed and processed by Ada",
        timestamp: formatTimestamp(row.confirmed),
      },
      {
        label: "Sent to Catalist",
        timestamp: formatTimestamp(row.catalist?.started),
      },
      {
        label: "Pre-enhancement received from Catalist",
        timestamp: formatTimestamp(row.catalist?.dwid_received),
      },
      {
        label: "RDS enhancement complete",
        timestamp: formatTimestamp(row.catalist?.completed),
      },
      {
        label: "File sent to VAN",
        timestamp: formatTimestamp(row.VAN?.sent),
      },
      {
        label: "File acknowledged by VAN",
        timestamp: formatTimestamp(row.VAN?.acknowledgement),
      },
      {
        label: "File posted to VAN",
        timestamp: formatTimestamp(row.VAN?.posted),
      },
    ];
    if (row.use === "catalist-only") {
      setSteps(allSteps.slice(0, 4));
    } else {
      setSteps(allSteps);
    }
  };

  return (
    <>
      <Tooltip title="See file processing history">
        <SiteIcons
          iconstring="history"
          color="gray"
          onClick={handleClickOpen}
        />
      </Tooltip>
      <Dialog
        open={open}
        slotProps={{
          paper: { sx: { width: "380px" } },
        }}
      >
        <DialogContent>
          <Typography variant="h3" sx={{ marginBottom: "5px" }}>
            File History
          </Typography>
          <Typography sx={{ fontSize: "1.2rem" }}>
            {parseAdaPath(row.ada_file).filename}
          </Typography>
          <Stepper
            data-testid="file-history-stepper"
            orientation="vertical"
            sx={{
              marginTop: "12px",
              "& .MuiStepIcon-root": { color: "grey.400" },
              "& .MuiStepIcon-root.Mui-active": { color: "primary.main" },
              "& .MuiStepIcon-root.Mui-completed": { color: "primary.main" },
            }}
          >
            {steps.map((step, index) => (
              <Step
                active={!!step.timestamp}
                key={step.label}
                className="file-history-step"
              >
                <StepLabel>{step.label}</StepLabel>
                <StepContent>
                  <Typography>{step.timestamp}</Typography>
                </StepContent>
              </Step>
            ))}
          </Stepper>
        </DialogContent>
        <DialogActions>
          <Button autoFocus className="siteBlueOutlined" onClick={handleClose}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
